import none from '../../img/kandokLogo.jpg'
export const hotDrink =[
 {
  "id": 71,
  "title": "اسپرسو سینگل",
  "price": 40,
  "image": none
 },
 {
  "id": 72,
  "title": "اسپرسو دبل",
  "price": 50,
  "image": none
 },
 {
  "id": 73,
  "title": "قهوه ترک",
  "price": 50,
  "image": none
 },
 {
  "id": 74,
  "title": "کاپوچینو",
  "price": 65,
  "image": none
 },
 {
  "id": 75,
  "title": "هات چاکلت",
  "price": 60,
  "image": none
 },
 {
  "id": 76,
  "title": "دمنوش زعفران",
  "price": 90,
  "image": none
 },
 {
  "id": 77,
  "title": "دمنوش آویشن و پونه",
  "price": 60,
  "image": none
 },
 {
  "id": 78,
  "title": "دمنوش دارچین و آلبالو",
  "price": 80,
  "image": none
 }
]